<template>
  <div class="branding-preview" :style="{ background: branding.tertiaryColor }">
    <div class="branding-top-video" />
    <div class="branding-bottom-videos">
      <div />
      <div />
      <div :style="{ borderColor: branding.fourthColor }" />
      <div />
    </div>
    <div class="branding-sidebar">
      <img :src="branding.logoSrc" class="branding-logo" />
      <div class="braning-icons" :style="{ color: branding.secondaryColor }">
        <b-icon size="is-small" icon="format-align-left" class="mx-2" />
        <b-icon size="is-small" icon="forum" class="mx-2" />
        <b-icon size="is-small" icon="account" class="mx-2" />
        <b-icon size="is-small" icon="cog" class="mx-2" />
      </div>
      <div class="branding-button" :style="{ background: branding.primaryColor }" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandingPreview",
  props: {
    branding: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style sccoped>
.branding-preview {
  width: 840px;
  height: 480px;
  position: relative;
  background: #121c2e;
  border: 2px solid #000;
}

.branding-sidebar {
  position: absolute;
  width: 25%;
  height: 100%;
  background: #fff;
  right: 0;
  top: 0;
}

.branding-button {
  width: 50px;
  height: 16px;
  position: absolute;
  bottom: 26px;
  left: 20px;
}

.braning-icons {
  font-size: 20px;
  position: absolute;
  right: 16px;
  top: 80px;
}

.branding-logo {
  position: absolute;
  top: 15px;
  left: 15px;
  height: 40px;
}

.branding-top-video {
  position: absolute;
  top: 75px;
  left: 100px;
  width: calc(75% - 200px);
  height: 260px;
  border: 2px solid #fff;
  border-radius: 3px;
}

.branding-bottom-videos {
  position: absolute;
  width: calc(75% - 200px);
  height: 60px;
  left: 100px;
  top: 370px;
  display: flex;
  justify-content: space-evenly;
}

.branding-bottom-videos > div {
  width: 20%;
  height: 60px;
  border: 2px solid #fff;
  border-radius: 3px;
}
</style>
